
// 左侧菜单配
const menuInfo = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '个人中心',
    auth: 'Pages.GR.GR00Menu',
    subNodes: [
      { path: '/gr/profile', name: '个人信息' },
      { path: '/gr/gr01', auth: 'Pages.GR.GR01', name: '学习经历' },
      { path: '/gr/gr02', auth: 'Pages.GR.GR02', name: '工作经历' },
      { path: '/gr/gr03', auth: 'Pages.GR.GR03', name: '学术任职' },
      { path: '/gr/gr04', auth: 'Pages.GR.GR04', name: '荣誉嘉奖' },
      { path: '/gr/gr05', auth: 'Pages.GR.GR05', name: '个人简介' },
      { path: '/gr/gr06', auth: 'Pages.GR.GR06', name: '个人简历' },
      { path: '/gr/gr07', auth: 'Pages.GR.GR07', name: '招聘应聘' }
    ]
  },
  {
    name: '团队管理',
    auth: 'Pages.TD.TD00Menu',
    subNodes: [
      { path: '/td/td01', name: '我的好友' },
      { path: '/td/td02', name: '科研团队' },
      { path: '/td/td03', name: '合作团队' },
      { path: '/td/td04', name: '临时团队' },
      { path: '/td/td05', name: '历史团队' },
      { path: '/td/td06', auth: 'Pages.TD.td06', name: '组织架构' },
      { path: '/td/td07', auth: 'Pages.EndUserDanWei', name: '单位' }
    ]
  },
  {
    name: '工作管理',
    auth: 'Pages.GZ00.GZMenu',
    subNodes: [
      {
        name: '行政管理',
        auth: 'Pages.GZ01.XZ00Menu',
        subNodes: [
          { path: '/gz/xz/xz01', auth: 'Pages.GZ01.xz01', name: '任务管理' },
          { path: '/gz/xz/xz02', auth: 'Pages.GZ01.xz02', name: '事务管理' },
          { path: '/gz/xz/xz03', auth: 'Pages.GZ01.xz03', name: '制度管理' }
        ]
      },
      {
        name: '教学管理',
        auth: 'Pages.GZ02.JX00Menu',
        subNodes: [
          { path: '/gz/jx/jx01', auth: 'Pages.GZ02.jx01', name: '课程管理' },
          { path: '/gz/jx/jx02', auth: 'Pages.GZ02.jx02', name: '教改课题' },
          { path: '/gz/jx/jx03', auth: 'Pages.GZ02.jx03', name: '教学论文' },
          { path: '/gz/jx/jx04', auth: 'Pages.GZ02.jx04', name: '教材编写' },
          { path: '/gz/jx/jx05', auth: 'Pages.GZ02.jx05', name: '教学成果' }
        ]
      },
      {
        name: '科研管理',
        auth: 'Pages.GZ03.KY00Menu',
        subNodes: [
          { path: '/gz/ky/ky01', auth: 'Pages.GZ03.ky01', name: '我的实验' },
          { path: '/gz/ky/ky02', auth: 'Pages.GZ03.ky02', name: '项目课题' },
          { path: '/gz/ky/ky03', auth: 'Pages.GZ03.ky03', name: '发表论文' },
          { path: '/gz/ky/ky04', auth: 'Pages.GZ03.ky04', name: '编写专著' },
          { path: '/gz/ky/ky05', auth: 'Pages.GZ03.ky05', name: '申报专利' },
          { path: '/gz/ky/ky06', auth: 'Pages.GZ03.ky06', name: '产品批件' },
          { path: '/gz/ky/ky07', auth: 'Pages.GZ03.ky07', name: '成果奖项' },
          { path: '/gz/ky/ky08', auth: 'Pages.GZ03.ky08', name: '成果转化' },
          { path: '/gz/ky/ky09', auth: 'Pages.GZ03.ky09', name: 'SOP' }
        ]
      },
      {
        name: '学术管理',
        auth: 'Pages.GZ04.XS00Menu',
        subNodes: [
          { path: '/gz/xs/xs01', auth: 'Pages.GZ04.xs01', name: '学术任职' },
          { path: '/gz/xs/xs02', auth: 'Pages.GZ04.xs02', name: '咨询评审' }
        ]
      }
    ]
  },
  {
    name: '资源管理',
    auth: 'Pages.ZY.ZY00Menu',
    subNodes: [
      { path: '/zy/zy01', auth: 'Pages.ZY.zy01', name: '仪器管理' },
      { path: '/zy/zy02', auth: 'Pages.ZY.zy02', name: '耗材管理' },
      { path: '/zy/zy03', auth: 'Pages.ZY.zy03', name: '技术服务' },
      { path: '/zy/zy04', auth: 'Pages.ZY.zy04', name: '成果转化' },
      { path: '/zy/zy05', auth: 'Pages.ZY.zy05', name: '信息发布' },
      { path: '/zy/zy06', auth: 'Pages.ZY.zy06', name: '科研资讯' }
    ]
  }
]

export default {
  menuInfo
}
